<template>
    <div>
        <Search v-model="searchText" placeholder="请输入搜索关键词"/>
        <CellGroup style="height: calc(100vh - 110px);overflow-y: auto">
            <Cell v-for="(unit) in searchUnit " is-link
                  :title="unit.name" :key="unit.id"
                  @click="$emit('onSelect',unit)"
            />
        </CellGroup>
    </div>
</template>

<script>
    import {Cell, CellGroup, Search} from 'vant';

    export default {
        components: {Cell, CellGroup, Search},
        computed: {
            searchUnit() {
                return this.unitList.filter(item => item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0)
            },
        },
        mounted() {
            this.loadUnitList()
        },
        data() {
            return {searchText: '', unitList: []}
        },
        methods: {
            loadUnitList() {
                this.$http.tokiot.sys.unit.v2.list({size: 99999})
                    .then(ret => {
                        if (ret) {
                            this.unitList = ret.rows
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>